import { useAtom } from 'jotai'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import useToken from '../../../helpers/useTokens'
import { Box, Button, Stack, Table, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useDispatch } from 'react-redux'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { getPaymentTypeBackground, getStatusBackground, navigation3 } from '../../../common/helper'
import moment from 'moment'
import { RenderTable } from '../analysisReport/summmaryTable'
import { useEffect, useRef, useState } from 'react'
import { cellStyles, headCellStyles, paymentTypeStyles, statusCellStyles, summaryTableHead, trimmedTextStyle } from './const'
import React from 'react'
import { RenderTableExcel } from '../analysisReport/summaryTableExcel'

const reportName = 'Booking And Delivery Tacking Summary Report'
const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')

export const BkngDelvryTrackingSummary = (props) => {
  const { dataValues } = props
  const dispatch = useDispatch()
  const [companySettings] = useAtom(companySettingsAtom)
  const [roleRights] = useAtom(CargoRoleRightsAtom)
  const { UseFormattedLRinReports } = companySettings
  const { loginData } = useToken()
  const [tableHead, setTableHead] = useState([])
  const [tableHead2, setTableHead2] = useState([])
  const [tableData, setTableData] = useState([])
  const [maxHeight, setMaxHeight] = useState('350px')
  const tableRef = useRef(null)
  const { trackingReportTableData, selectedRadio, fromDate, toDate, companyName } = dataValues
  const { srcState, srcCity, srcBranch, destState, destCity, destBranch, paymentType, consignmentType, transactionType } = dataValues

  useEffect(() => {
    if (UseFormattedLRinReports) {
      setTableHead(summaryTableHead)
      setTableHead2(summaryTableHead.map((item) => ({ ...item, field: item.field2 || item.field })))
    } else {
      const fileted = summaryTableHead.filter((item) => item.field !== 'FormattedLRNO')
      setTableHead(fileted)
      setTableHead2(fileted.map((item) => ({ ...item, field: item.field2 || item.field })))
    }
  }, [UseFormattedLRinReports])
  useEffect(() => {
    setTableData(
      trackingReportTableData.map((item, index) => {
        return {
          ...item,
          sn: index + 1,
          FormattedLRNO: item.FormattedLRNO,
          BookingDateFormated: item.BookingDate?.slice(0, 10),
          BookingTimeFormated: item.BookingDate?.slice(11, 19),
          RefundDateFormated: item?.RefundDate?.slice(0, 10),
          RefundTimeFormated: item?.RefundDate?.slice(11, 19),
          DispatchDateTimeFormated: item?.DispatchDateTime?.slice(0, 10),
          DispatchDateTimeFormated: item?.DispatchDateTime?.slice(11, 19),
          ReceiveDateFormated: item?.ReceiveDate?.slice(0, 10),
          ReceiveTimeFormated: item?.ReceiveDate?.slice(11, 19),
          DeliveryDateFormated: item?.DeliveryDate?.slice(0, 10),
          DeliveryTimeFormated: item?.DeliveryDate?.slice(11, 19),
          PaymentTypeFormated: (
            <div style={{ ...paymentTypeStyles, width: '95px' }}>
              {' '}
              <span
                style={{
                  fontSize: '12px',
                  backgroundColor: getPaymentTypeBackground(item?.PaymentType),
                  padding: '2px 8px',
                  borderRadius: '30px',
                  textDecoration: item?.PaymentType?.length > 7 ? 'underline' : '',
                }}
                title={item?.PaymentType}
              >
                {item?.PaymentType}
              </span>
            </div>
          ),
          ConsTypeFormatted: item?.ConsType?.split(',').map((value, i) => (
            <div
              key={i}
              style={{ ...trimmedTextStyle, fontSize: '12px', textDecoration: value?.length > 19 ? 'underline' : '' }}
              title={value}
            >
              {value.trim()}
            </div>
          )),
          StatusFormated: (
            <div style={{ ...statusCellStyles, width: '100%', padding: '4px 0px' }}>
              <span
                style={{
                  fontSize: '12px',
                  backgroundColor: getStatusBackground(item.Status),
                  padding: '2px 4px',
                  borderRadius: '30px',
                  textDecoration: item?.Status?.length > 10 ? 'underline' : '',
                  whiteSpace: 'nowrap',
                }}
                title={item?.Status}
              >
                {item.Status}
              </span>
            </div>
          ),
        }
      })
    )
  }, [trackingReportTableData])
  useEffect(() => {
    if (tableRef.current) {
      const tableHeight = tableRef.current.offsetHeight
      const windowHeight = window.innerHeight
      const maxHeight = windowHeight - tableHeight - 100
      console.log(maxHeight)
      setMaxHeight(maxHeight + 'px')
    }
  }, [tableRef])
  return (
    <>
      <Box
        className="userReport"
        style={{ display: 'flex', width: '100%', height: '40px', padding: '12px 0px', marginRight: '0px', marginTop: '5px' }}
      >
        <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
          <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '16px' }}>Report For: {reportName}</h3>
        </Box>
        <Box
          className="userReport-buttons"
          style={{
            display: 'flex',
            width: '50%',
            justifyContent: 'end',
            alignItems: 'center',
            paddingRight: '16px',
          }}
        >
          <Box>
            {roleRights?.Table1[0]?.AllowExportExcel === 1 ? (
              <div
                onKeyDown={(e) => {
                  navigation3(e, 'isBookingDateWise', 'bdtSplitButton', () => {})
                }}
              >
                <ReactHtmlTableToExcel
                  id="bdt-excel-button"
                  className="userWisereporttemExcelBtn"
                  table="bkngDelvryTrckingSummaryExcelTbl"
                  filename={`${reportName} ${currentDateTime}`}
                  sheet="sheet1"
                  buttonText="Export to Excel"
                />
              </div>
            ) : (
              <Button variant="outlined" className="userWisereporttembtn" onClick={() => {}} disabled={true}>
                Export As Excel
              </Button>
            )}
          </Box>
        </Box>
      </Box>
      <Stack ref={tableRef} style={{ padding: '10px 15px 10px 15px', maxHeight: maxHeight }}>
        <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid #ddd' }}>
          <RenderTable
            header={tableHead}
            data={tableData}
            key1={'fewr34'}
            key2={'vsd0w3'}
            key3={'ves043'}
            headerFontSize="12px"
            bodyFontSize="12px"
            tableStyle={{ tableLayout: 'fixed' }}
            headcolStyle={{ padding: '5px' }}
            datacolStyle={{ padding: '5px 0px 5px 5px' }}
          />
        </TableContainer>
        <Table id="bkngDelvryTrckingSummaryExcelTbl" style={{ border: 'none', display: 'none' }}>
          <TableHead style={{ fontWeight: 'bold' }}>
            <TableRow>
              <TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
                colSpan={7}
              >
                <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>{reportName}</h3>
              </TableCell>
              <TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
                colSpan={7}
              >
                <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>Company Name : {loginData.strCompanyName}</h3>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={14}></TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
                colSpan={7}
              >
                <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '16px' }}>
                  {`${selectedRadio} Date`}: {moment(fromDate).format('DD-MMM-YYYY')} To {moment(toDate).format('DD-MMM-YYYY')}
                </h3>
              </TableCell>
              <TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
                colSpan={7}
              >
                <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '16px' }}>
                  Report View : {`${selectedRadio} Date Wise`}
                </h3>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={14}></TableCell>
            </TableRow>
            <TableRow style={{ color: '#444444' }}>
              <TableCell
                className="ReportItemHead"
                style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={3}
              >
                Company Name
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Source State
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={3}
              >
                Source City
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={3}
              >
                Source Branch
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={3}
              >
                Payment Type
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className="ReportItemHead"
                style={{
                  ...cellStyles,
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '500',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={3}
              >
                {companyName}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  ...cellStyles,
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '500',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={2}
              >
                {srcState?.name}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  ...cellStyles,
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '500',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={3}
              >
                {srcCity?.name}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  ...cellStyles,
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '500',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={3}
              >
                {srcBranch?.name}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  ...cellStyles,
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '500',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={3}
              >
                {paymentType?.Name}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={14}></TableCell>
            </TableRow>
            <TableRow style={{ color: '#444444' }}>
              <TableCell
                className="ReportItemHead"
                style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={3}
              >
                Destination State
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Destination City
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={3}
              >
                Destination Branch
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={3}
              >
                Consignment Type
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ ...headCellStyles, fontWeight: '650', fontSize: '16px', textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={3}
              >
                Transaction Type
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className="ReportItemHead"
                style={{
                  ...cellStyles,
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '500',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={3}
              >
                {destState?.name}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  ...cellStyles,
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '500',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={2}
              >
                {destCity?.name}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  ...cellStyles,
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '500',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={3}
              >
                {destBranch?.name}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  ...cellStyles,
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '500',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={3}
              >
                {consignmentType?.name}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  ...cellStyles,
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '500',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={3}
              >
                {transactionType?.name}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={14}></TableCell>
            </TableRow>
          </TableHead>
          <RenderTableExcel header={tableHead2} data={tableData} key1={'fewewr34'} key2={'v34d0w3'} key3={'ves0340d43'} />
        </Table>
      </Stack>
    </>
  )
}
